// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SelectizeController from "./selectize_controller"
application.register("selectize", SelectizeController)

import TooltipsController from "./tooltips_controller"
application.register("tooltips", TooltipsController)

import DatetimeController from "./datetime_controller"
application.register("datetime", DatetimeController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import UserInfoController from "./user_info_controller"
application.register("user-info", UserInfoController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import DirectBookingController from "./direct_booking_controller"
application.register("direct-booking", DirectBookingController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import OfftimesController from "./offtimes_controller"
application.register("offtimes", OfftimesController)

import SubmitFormController from "./submit_form_controller"
application.register('submit-form', SubmitFormController)

import ToggleController from "./toggle_controller"
application.register('toggle', ToggleController)

import DisableWithCheckbox from "./disable_with_checkbox_controller"
application.register('disable-with-checkbox', DisableWithCheckbox)

import Tomselect from "./tomselect_controller"
application.register('tomselect', Tomselect)

import ModalController from "./modal_controller"
application.register('modal', ModalController)

import ToastController from "./toast_controller"
application.register('toast', ToastController)

import ChartController from "./chart_controller"
application.register('chart', ChartController)

import AvailabilityController from "./availability_controller"
application.register('availability', AvailabilityController)

import CalendarController from "./calendar_controller"
application.register('calendar', CalendarController)
